import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SendIcon from './icons/SendIcon';
import FileIcon from './icons/FileIcon';
import { localize } from 'react-localize-redux';
import TextField from '@material-ui/core/TextField';

class UserInput extends Component {
  constructor() {
    super();
    this.state = {
      inputActive: false,
      inputHasText: false,
      text: '',
      typing: false,
    };
  }

  handleKeyDown(event) {
    if (event.keyCode === 13 && !event.shiftKey) {
      return this._submitText(event);
    }
  }

  handleKeyUp(event) {
    const inputHasText =
      (this.state.text.length !== 0 && this.state.text !== '\n') || this.state.text !== '';

    this.setState({ inputHasText });
  }

  _showFilePicker() {
    this._fileUploadButton.click();
  }

  handleChange = event => {
    this.setState({ text: event.target.value });
    if (event.target.value.length > 0 && !this.state.typing) {
      this.setState({ inputHasText: true });
    }
    if (event.target.value.length === 0 && this.state.typing) {
      this.setState({ inputHasText: false });
    }
  };

  _submitText(event) {
    event.preventDefault();
    const text = this.state.text;
    if (text && text.length > 0) {
      this.props.onSubmit({
        author: 'me',
        type: 'text',
        data: { text },
      });
      this.setState({ text: '', inputHasText: false });
    }
  }

  _onFilesSelected(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.props.onFilesSelected(event.target.files);
    }
  }

  _renderSendOrFileIcon() {
    if (this.state.inputHasText) {
      return (
        <div className="sc-user-input--button">
          <SendIcon onClick={this._submitText.bind(this)} />
        </div>
      );
    }
    return (
      <div className="sc-user-input--button">
        <FileIcon onClick={this._showFilePicker.bind(this)} />
        <input
          type="file"
          name="files[]"
          multiple
          ref={e => {
            this._fileUploadButton = e;
          }}
          onChange={this._onFilesSelected.bind(this)}
        />
      </div>
    );
  }

  render() {
    const { inputActive } = this.state;
    return (
      <form className={`sc-user-input ${inputActive ? 'active' : ''}`}>
        <TextField
          multiline
          rows="3"
          fullWidth
          value={this.state.text}
          onChange={this.handleChange}
          variant="outlined"
          label={this.props.translate('tenantPortal.chat.writeAReply')}
          onKeyDown={this.detectEnterKeyDown}
          inputProps={{
            'aria-label': this.props.translate('tenantPortal.chat.writeAReply').props.children,
          }}
          style={{ paddingRight: '55px' }}
        />
        <div className="sc-user-input--buttons">
          <div className="sc-user-input--button" />
          {this._renderSendOrFileIcon()}
        </div>
      </form>
    );
  }
}

UserInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func.isRequired,
};

export default localize()(UserInput);
